module.exports = __webpack_public_path__ + "img/hp_0.0338828d.jpg";